import type { RouteLocationNormalized } from 'vue-router'
import { DEFAULT_APP_PLATFORM } from '@/const/platformAccess'

/** Route names that skip subscription/platform checks (checkout, auth, static pages). */
export const SKIP_PLATFORM_ACCESS_ROUTE_NAMES = new Set([
  'Login',
  'Register',
  'ForgotPassword',
  'ResetPassword',
  'NotFound',
  'PermissionDenied',
  'TermsAndConditions',
  'PrivacyPolicy',
  'SignIn',
  'AuthCallback',
  'CompleteProfile',
  'Subscription',
  'SubscriptionManage',
  'Subscription Layout',
  'Subscription Manage Layout'
])

export function shouldSkipPlatformAccessCheck(to: RouteLocationNormalized): boolean {
  const name = to.name as string | undefined
  if (name && SKIP_PLATFORM_ACCESS_ROUTE_NAMES.has(name)) {
    return true
  }
  if (to.path.startsWith('/tuition')) {
    return true
  }
  return false
}

/** Deepest matched `meta.requiresPlatform`, or the default app platform code (campus). */
export function getRequiredPlatformForRoute(to: RouteLocationNormalized): string {
  for (const record of [...to.matched].reverse()) {
    const p = record.meta.requiresPlatform
    if (typeof p === 'string' && p.length > 0) {
      return p
    }
  }
  return DEFAULT_APP_PLATFORM
}
